/**
 * Editorial-collage element: positions a paper-cutout-style asset like a magazine sticker.
 *
 * Props:
 *   src     — image url (white paper bg)
 *   w       — width in px (height auto)
 *   rotate  — degrees (-15..+15 looks editorial)
 *   top/right/bottom/left — absolute position (use string like "12%" or "-30px")
 *   blend   — "multiply" (default, for cream bg) | "screen" (for dark bg) | "normal"
 *   z       — z-index
 *   opacity — number 0..1
 *   className — extra
 *
 * Parent must be `position: relative`.
 */
export default function Collage({
  src,
  w = 140,
  rotate = 0,
  top, right, bottom, left,
  blend = "multiply",
  z = 1,
  opacity = 1,
  className = "",
  alt = "",
  "data-testid": testid,
}) {
  return (
    <img
      src={src}
      alt={alt}
      data-testid={testid}
      aria-hidden={alt ? undefined : true}
      style={{
        position: "absolute",
        width: w,
        height: "auto",
        top, right, bottom, left,
        transform: `rotate(${rotate}deg)`,
        mixBlendMode: blend,
        opacity,
        zIndex: z,
        pointerEvents: "none",
        filter: blend === "screen" ? "invert(1) contrast(1.05)" : "none",
        userSelect: "none",
      }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}
